<template>
    <v-btn
        v-tooltip:bottom="$t('tips_title')"
        color="black"
        :icon="icon"
        variant="text"
        size="small"
        density="comfortable"
    />
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class ServiceTipsIcon extends Vue {
        get icon() {
            return 'mdi-note-multiple-outline'
        }
    }

    export default ServiceTipsIcon
</script>
